import { render, staticRenderFns } from "./DetailedKPAList.vue?vue&type=template&id=9cb03424&scoped=true"
import script from "./DetailedKPAList.vue?vue&type=script&lang=js"
export * from "./DetailedKPAList.vue?vue&type=script&lang=js"
import style0 from "./DetailedKPAList.vue?vue&type=style&index=0&id=9cb03424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb03424",
  null
  
)

export default component.exports